import React, { Suspense } from "react";
import CraftingResultSlot from "../CraftingResultSlot";
import InventoryGroup from "../InventoryGroup";
import Steve3D from "../Steve3D";

export default function Inventory({ bgImg = "/inventory.png" }) {
  return (
    <div
      className="flex flex-col items-center gap-3 p-5 pixelated"
      style={{
        backgroundImage: `url('${bgImg}')`,
        backgroundSize: "contain",
      }}
    >
      <div className="flex justify-between w-full">
        <div className="flex items-end h-full">
          <div className="flex flex-col">
            <InventoryGroup type="armor" />
          </div>
          <div className="mc-grid !h-[216px] !w-[153px]" style={{ background: "radial-gradient(ellipse at center, #353846 0%, #111217 100%)", boxShadow: "inset 0 0 14px rgba(0, 0, 0, 0.7)" }}>
            <Suspense fallback={null}>
              <Steve3D />
            </Suspense>
          </div>
          <InventoryGroup type="offhand" />
        </div>
        <div className="-mr-[6px]">
          <span className="text-2xl text-[#404040] ">Crafting</span>
          <div className="flex items-center -mt-px">
            <InventoryGroup type="inventoryCrafting" />
            <CraftingResultSlot
              type="inventoryCraftingResult"
              resultOfType="inventoryCrafting"
              className="ml-[60px] mt-[6px]"
            />
          </div>
        </div>
      </div>
      <InventoryGroup type="inventory" chatTarget />
      <InventoryGroup type="hotbar" />
    </div>
  );
}
